import $ from 'jquery'

function ChartDateRangeSectionStrategy() {}

ChartDateRangeSectionStrategy.prototype.init = function( container, dateRangeSelector, singleDateSelector )
{
    this.container = container;
    this.dateRangeSelector = dateRangeSelector;
    this.singleDateSelector = singleDateSelector;

    return this;
};

ChartDateRangeSectionStrategy.prototype.updateSectionUI = function()
{
    $( this.container ).removeClass( "withDateRangeSelector withSingleDateSelector" );
};

ChartDateRangeSectionStrategy.prototype.getSelectedParamsJSON = function()
{
    return [];
};

ChartDateRangeSectionStrategy.prototype.getSelectedParams = function()
{
    // abstract
};

ChartDateRangeSectionStrategy.prototype.validate = function()
{
    return [];
};

export default ChartDateRangeSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartDateRangeSectionStrategy.js